import { string } from 'yup';

export const firstNameSchema = string()
  .nullable()
  .trim()
  .required('Please fill out this field')
  .min(2, 'Must be at least 2 characters')
  .max(30, 'No more than 30 characters');
